module.exports = __webpack_public_path__ + "media/images/sales/early/eyecatch-early-02-31d4b92cf9a9c8f134f421e648a257db.svg";